import { Label as LabelPrimitive } from '@radix-ui/react-label';
import { styled } from '../../system';
export const Label = styled(LabelPrimitive, {
    fontFamily: '$sans',
    fontWeight: '$medium',
    color: '$text',
    textSm: true
});
Label.displayName = 'Label';
